import { useEffect } from 'react';
import { useState } from 'react';
import { useValue } from './useValue';
import { ResizeObserver } from '@juggle/resize-observer';
/**
 * Manages the bounds of an element.
 * @function useMeasure
 * @since 1.0.0
 */
export function useMeasure(node) {
    var _a, _b, _c, _d;
    const [bounds, setBounds] = useState(new DOMRectReadOnly());
    const [scrollWidth, setScrollWidth] = useState((_b = (_a = node.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) !== null && _b !== void 0 ? _b : 0);
    const [scrollHeight, setScrollHeight] = useState((_d = (_c = node.current) === null || _c === void 0 ? void 0 : _c.scrollWidth) !== null && _d !== void 0 ? _d : 0);
    const observer = useValue(() => {
        return new ResizeObserver(([entry]) => {
            var _a, _b, _c, _d;
            setBounds(entry.contentRect);
            setScrollWidth((_b = (_a = node.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) !== null && _b !== void 0 ? _b : 0);
            setScrollHeight((_d = (_c = node.current) === null || _c === void 0 ? void 0 : _c.scrollHeight) !== null && _d !== void 0 ? _d : 0);
        });
    });
    useEffect(() => {
        const element = node.current;
        if (element == null) {
            return;
        }
        observer.observe(element);
        return () => {
            observer.disconnect();
        };
    }, [node, observer]);
    return [bounds, scrollWidth, scrollHeight];
}
